import { Store } from '../../../store/list/types';
import { deselectAllRecordings } from './deselectAllRecordings';
import { toggleSelectRecordings } from './toggleSelectRecordings';

export const toggleSelectPageRecordings = (store: Store): void => {
  const { selectedRecordings, recordings } = store.getState();
  // If we already have a selection, we need to deselect.
  if (selectedRecordings.length > 0) {
    deselectAllRecordings(store);
  } else {
    toggleSelectRecordings(store, recordings, true);
  }
};
